import React, { Component } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import moment from 'moment/moment'
import _ from 'lodash'

import { Button, Card, Col, Drawer, Form, notification, Row, Tooltip, Checkbox } from 'antd/lib/index'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'

import { connect } from 'react-redux'
import styles from './styles.less'

import lodash from 'lodash'

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'

let userCheckBox = {}
let counsellingData = {}

@Form.create()
class DrawerForm extends Component {
    handleSubmit = e => {
        const { form, handleSubmit, inquiryId, dueInvoiceId } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                this.setState({ loading: true })
                values._id = inquiryId
                values.dueInvoiceId = dueInvoiceId

                let x = await Request.updateDueInvoiceBranchStatus(values)


                if (!x.error) {

                    notification.success({
                        message: x.msg

                    })
                    if (handleSubmit) {
                        handleSubmit()
                    }
                    form.resetFields()


                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }

                this.setState({ loading: false })


            }
        })
    }

    constructor(props) {
        super(props)
        this.state = { loading: false }
    }

    render() {

        const commentBox = {
            fields: [

                {
                    label: 'Select Status',
                    key: 'status',
                    type: 'select',
                    customProps: {
                        style: {
                            width: '60%'
                        }
                    },
                    options: ['Branch/Partner Invoice Received', 'Branch/Partner Invoice Paid'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ status: v })
                    }
                }
            ]
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: {
                    span: 8,
                    md: { span: 4 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                    md: { span: 12 }
                }
            }
        }
        const {
            form: { getFieldDecorator }
        } = this.props
        return (


            <Form onSubmit={this.handleSubmit} hideRequiredMark>

                <Row>
                    <Col span={24}>
                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={commentBox}
                            getFieldDecorator={getFieldDecorator}
                            formItemLayout={formItemLayout}
                        />
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={this.state.loading}>
                                UPDATE
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }
}

class branchInvoices extends Component {
    state = {
        count: 0,
        channelPartnerList: [],
        allBranches: [],
        deskColor: null,
        leadSourceList: ['University', 'Channel Partner'],
        invoiceBranchStatusList: ['Branch/Partner can submit Invoice', 'Branch/Partner Invoice Received', 'Branch/Partner Invoice Paid'],

        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},
    }
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showSMS: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({ showSMS: false })
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked === true ? item : false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showWhatsAppSms: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeWhatsSMS = () => {
        this.setState({ showWhatsAppSms: false })
    }
    closeEmail = () => {
        this.setState({ showEmail: false })
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showEmail: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }
            params.atLevel = ['Claim Desk']
            params.branchDueInvoice = 'Branch Due Invoice'

            let data = await Request.dueInvoicesList({
                ...params
            })

            delete data.error
            delete data.type

            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({ count: data.data.length, allBranches: data.allBranches, userCheckBox: userCheckBox })
            resolve(data)
        })
    }


    loadChannelPartners = async () => {
        let { data: channelPartnerList } = await Request.getSimplePartners({
            results: 10000
        })
        this.setState({ channelPartnerList })
    }

    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        this.setState({ claimDeskRights: userRights.ClaimDesk })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.loadChannelPartners()
        this.loadUserRights()
    }

    showDrawer = () => {
        this.setState({
            visible: true
        })
    }


    async componentDidMount() {

    }

    render() {
        const {
            allBranches = [],
            invoiceBranchStatusList,
            deskColor,
            channelPartnerList,
            leadSourceList,
            dueInvoiceId,
            inquiryId,
            claimDeskRights
        } = this.state


        const columns = [
            {
                title: 'Action',
                key: 'opertaions',
                width: 80,
                fixed: true,
                render: (text, record) => {
                    let condition = record && record.dueInvoices
                    return (
                        <div>
                            <React.Fragment>
                                <div className={styles.btnWrapper}>
                                    <span className={styles.userSelectCheckbox}>
                                        <Checkbox
                                            checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                            onChange={y => {
                                                this.selectUser(y, record._id)
                                            }}>
                                        </Checkbox>
                                    </span>
                                </div>
                            </React.Fragment>
                            <Tooltip title="Click To Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    size={'small'}
                                    href={`/desk/branchInvoice/update?id=${record._id}&dueInvoiceId=${record && record.dueInvoices && record.dueInvoices._id}`}
                                    icon="edit"
                                />
                            </Tooltip>

                            {condition && condition.uploadBranchInvoice && condition.uploadBranchInvoice.length > 0 &&
                                <Tooltip title={'Download Invoice'}>
                                    <Button
                                        className={styles.btn}
                                        size={'small'}
                                        shape="circle"
                                        style={{
                                            marginLeft: '3px',
                                            backgroundColor: '#85CF4A',
                                            border: '1px solid #85CF4A',
                                            color: 'white'
                                        }}
                                        icon="download"
                                        onClick={() => {

                                            window.open(
                                                `${MEDIA_URL}/${condition.uploadBranchInvoice[0].url}`,
                                                '_blank'
                                            )

                                        }} /></Tooltip>}
                            {condition && condition.uploadBranchSignedInvoice && condition.uploadBranchSignedInvoice.length > 0 &&
                                <Tooltip title={'Download Signed Invoice'}>
                                    <Button
                                        size={'small'}
                                        className={styles.btn}
                                        style={{
                                            marginTop: '3px',
                                            backgroundColor: '#03A9F4',
                                            border: '1px solid #03A9F4',
                                            color: 'white'

                                        }}
                                        shape="circle"
                                        icon="download"
                                        onClick={() => {

                                            window.open(
                                                `${MEDIA_URL}/${condition.uploadBranchSignedInvoice[0].url}`,
                                                '_blank'
                                            )

                                        }} /></Tooltip>}

                            {condition && condition.uploadBranchPaymentProof && condition.uploadBranchPaymentProof.length > 0 &&
                                <Tooltip title={'Download Payment Proof'}>
                                    <Button
                                        className={styles.btn}
                                        size={'small'}
                                        shape="circle"
                                        style={{
                                            marginLeft: '3px',
                                            marginTop: '3px',
                                            backgroundColor: '#9C27B0',
                                            color: 'white',
                                            border: '1px solid #9C27B0'

                                        }}
                                        icon="download"
                                        onClick={() => {
                                            window.open(
                                                `${MEDIA_URL}/${condition.uploadBranchPaymentProof[0].url}`,
                                                '_blank'
                                            )
                                        }} /></Tooltip>}

                        </div>
                    )
                }
            },
            {
                title: 'ID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 80,
                fixed: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name (Mobile/WAP/E mail)',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                width: 200,
                fixed: true,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <Tooltip title="Click To Edit Details">
                                <a className={styles.btn} target={'_blank'}
                                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                >{text}</a>
                            </Tooltip>
                            <div>{record.mobile}</div>

                            <div>
                                {record.watsupp && record.watsupp.length === 10 ?
                                    <Tooltip title="Share on Whatsapp">
                                        <a target={'_blank'}
                                            style={{ textDecoration: 'underline' }}
                                            href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                    </Tooltip>
                                    : record.watsupp}

                            </div>
                            <div>{record.emailId}</div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'DOB ',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchDateName: 'dateOfBirth',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Course/University',
                key: 'selectedCourse',
                width: 250,
                dataIndex: 'visaDesk.selectedCourse',
                searchTextName: 'course/University',
                filterRegex: true,
                render: (text, record) => {
                    return (<div>
                        <div>{text ? text.courseName : ''}</div>
                        <div>{text ? text.universityInstitutionName : ''}</div>
                    </div>)
                }
            },
            {
                title: 'Course Start Date',
                key: 'courseStartDate',
                width: 100,
                dataIndex: 'visaDesk.courseStartDate',
                searchDateName: 'courseStartDate',
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Branch',
                key: 'branchId',
                filters: allBranches,
                width: 80,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Term',
                width: 70,
                key: 'invoiceNo',
                dataIndex: 'dueInvoices.invoiceNo',
                searchTextName: 'invoiceNo',
                filterRegex: true
            },
            {
                title: 'Invoice Ref No.',
                width: 100,
                key: 'invoiceRefNo',
                dataIndex: 'dueInvoices.invoiceRefNo',
                searchTextName: 'invoice Ref No',
                filterRegex: true
            },
            {
                title: 'Invoice Dated',
                key: 'invoiceDate',
                width: 100,
                searchDateName: 'invoiceDate',
                dataIndex: 'dueInvoices.invoiceDate',
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Invoice Due Date',
                key: 'dueDate',
                width: 100,
                searchDateName: 'dueDate',
                dataIndex: 'dueInvoices.dueDate',
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Tution Fee',
                key: 'tutionFee',
                dataIndex: 'dueInvoices.tutionFee',
                width: 80,
                render: (text, record) => {
                    return <div>{text && `${record.dueInvoices.currency} ${text}`}</div>
                }
            },
            {
                title: 'Total Commission',
                key: 'commission',
                dataIndex: 'dueInvoices.commission',
                width: 120,
                render: (text, record) => {
                    return <div>{text && `${record.dueInvoices.currency} ${record.dueInvoices.commissionAmount} (${text}%)`}</div>
                }
            },
            {
                title: 'Invoice Processed Date',
                key: 'invoiceProcessedDate',
                width: 100,
                dataIndex: 'dueInvoices.invoiceeInvoiceProcessedOn',
                //searchDateName: 'courseStartDate',
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Branch Commission',
                key: 'branchCommission',
                dataIndex: 'dueInvoices.branchCommission',
                width: 90,
                render: (text, record) => {
                    return <div>
                        {text && `${text}%`}
                    </div>
                }
            },
            {
                title: 'Invoice Amount',
                key: 'invoiceBranchCommAmount',
                dataIndex: 'dueInvoices.branchCommissionAmount',
                width: 80,
                render: (text, record) => {
                    return <div>{text && `${record.dueInvoices.currency} ${text}`}</div>

                }
            },
            {
                title: 'Invoice Status',
                key: 'invoiceBranchStatus',
                dataIndex: 'dueInvoices.branchInvoiceStatus',
                filters: invoiceBranchStatusList && invoiceBranchStatusList.map(x => ({ value: x, text: x })),
                width: 150


            }
        ]
        if (claimDeskRights && !claimDeskRights.viewByBranch) {

            let dataItem = {
                title: 'Invoicee',
                key: 'leadSource',
                dataIndex: 'leadSource',
                width: 180,
                filters: leadSourceList && leadSourceList.map(x => ({ value: x, text: x })),
                render: (text, record) => {
                    let found
                    if (record.visaDesk.channelPartnerId !== '') {
                        found = _.find(channelPartnerList, (item) => {
                            return item._id === record.visaDesk.channelPartnerId
                        })
                    }
                    return (<div>
                        <div>{text}</div>
                        <small style={{ color: '#ffa500' }}>{found ? found.channelPartnerName : ''}</small>
                    </div>)
                }
            }
            let dataItem1 = {
                title: 'Actions',
                key: 'opertaions22',
                width: 100,
                render: (text, record) => {
                    let condition = record && record.dueInvoices
                    return (
                        <div>
                            {condition && condition.branchInvoiceStatus !== 'Branch/Partner Invoice Paid' &&
                                <Button size={'small'} style={{
                                    fontSize: '12px',
                                    backgroundColor: '#1a73e8', color: 'white',
                                    border: '1px solid #1a73e8',
                                    borderRadius: '2px'

                                }} onClick={() => {
                                    this.setState({
                                        dueInvoiceId: record && record.dueInvoices._id,
                                        inquiryId: record && record._id
                                    }, () => {
                                        this.showDrawer()
                                    })

                                }}>Change Status</Button>}
                        </div>
                    )
                }
            }
            columns.splice(7, 0, dataItem)
            columns.push(dataItem1)

        }

        return (
            <PageHeaderWrapper deskColor={deskColor}
                title={`Branch/Associate Partner Due Invoices : ${this.state.count} `}>

                {this.state.showWhatsAppSms ? (
                    <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
                ) : null}

                {this.state.showSMS ? (
                    <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                ) : null}

                {this.state.showEmail ? (
                    <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
                ) : null}
                <Card style={{ marginBottom: 10 }}>
                    <div className={styles.filterBlock}>
                        <div className={styles.myBtnGroup}>
                            <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                                <Button
                                    className={styles.btn}
                                    type="primary"
                                    onClick={() => this.showEmail()}>Send E-mail
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showSMS()}>Send SMS
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showWhatsAppSms()}>Whatsapp
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.selectAllUserFxn()}>Select Visible
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                                </Button>
                            </div>
                        </div>
                    </div>
                </Card>

                <Card bordered={true}>
                    <TableComp
                        rowKey={(item, x) => {
                            return x
                        }}
                        columns={columns}
                        ref={this.table}
                        id={'claimDesk'}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: claimDeskRights && !claimDeskRights.viewByBranch ? 2100 : 1860 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

                <Drawer
                    title=""
                    forceRender={true}
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            visible: false
                        })
                    }}
                    visible={this.state.visible}
                    width={600}>
                    <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20, textAlign: 'center' }}>

                        {this.state.visible && <DrawerForm
                            dueInvoiceId={dueInvoiceId}
                            inquiryId={inquiryId}

                            handleSubmit={() => {

                                this.setState({ visible: false })
                                this.table.current.reload()

                            }} />}


                    </div>
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(branchInvoices)
